import { User } from "firebase/auth";
import { createContext } from "react";

interface IContextApp {
  user: (User & { address?: []; role: string; id: number }) | undefined;
  setUser: Function;
  addressIdForBuy: number | undefined;
  setAddressIdForBuy: Function;
}

const context: IContextApp = {
  user: undefined,
  setUser: () => {},
  addressIdForBuy: undefined,
  setAddressIdForBuy: () => {},
};

export const ContextApp = createContext(context);
